import React from "react";

const BookOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.738"
      height="19.633"
      viewBox="0 0 22.738 19.633"
    >
      <g id="book-outline" transform="translate(-31.5 -63.5)">
        <path
          id="Path_16"
          data-name="Path 16"
          d="M42.869,68.658c.776-3.065,3.709-4.63,10.093-4.658a.773.773,0,0,1,.776.776V78.751a.776.776,0,0,1-.776.776c-6.211,0-8.61,1.252-10.093,3.105-1.474-1.844-3.882-3.105-10.093-3.105a.8.8,0,0,1-.776-.87V64.776A.773.773,0,0,1,32.776,64C39.16,64.029,42.093,65.593,42.869,68.658Z"
          transform="translate(0 0)"
          fill="none"
          stroke="#5fd068"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <line
          id="Line_1"
          data-name="Line 1"
          y2="13.724"
          transform="translate(42.869 68.909)"
          fill="none"
          stroke="#5fd068"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="bookmark_1_"
          data-name="bookmark (1)"
          d="M7.773,10.393a.144.144,0,0,1-.107-.056L6.493,9.005,5.32,10.336a.129.129,0,0,1-.213,0A.576.576,0,0,1,5,9.973V3.259C5,2.564,5.287,2,5.64,2H7.346c.353,0,.64.564.64,1.259V9.973c0,.232-.1.419-.213.42Z"
          transform="translate(36.376 64.113)"
          fill="#00ad67"
        />
      </g>
    </svg>
  );
};

export default BookOutline;
